// extracted by mini-css-extract-plugin
export var listContent = "index-module--listContent---8yB+";
export var listLoop = "index-module--listLoop--6DWo1";
export var smallSwiper = "index-module--smallSwiper--KHILU";
export var swiperContainer = "index-module--swiperContainer--724tS";